import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const BannerStyled = styled(Box)(() => ({
  "& .MuiAlert-root": {
    "& .MuiAlert-icon": { display: "none" },
    display: "flex",
    justifyContent: "center",
  },
  justifyContent: "center",
  textAlign: "center",
  margin: "0.5rem 0.5rem 1.25rem",
  "& .icon": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const Styled = styled(Box)(({ theme }) => ({
  "& .MuiDivider-root": {
    backgroundColor: "#d8d8d8",
    ...theme.applyStyles("light", {
      backgroundColor: undefined,
    }),
  },
  "& .MuiTypography-root": {
    marginBottom: "0.625rem",
    color: "#fff",
    ...theme.applyStyles("light", {
      color: "rgb(1, 67, 97)",
    }),
  },
  "& .feeValue": {
    color: "#71cbf5",
    ...theme.applyStyles("light", {
      color: undefined,
    }),
  },
  "& .table": {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    marginTop: "0.625rem",
    flexDirection: "column",
  },
  "& .MuiTableRow-root": {
    "& td, & th":
      theme.palette.mode === "light"
        ? undefined
        : {
            borderColor: "#d8d8d8",
          },
  },
  "& .MuiTable-root": {
    margin: "0 auto",
    width: "90%",
    [theme.breakpoints.up("sm")]: {
      width: "50%",
    },
  },
}));

export default Styled;
